import * as MuiIcons from '@mui/icons-material';
import { Box } from '@mui/material';
import React from 'react';

interface CommandIconFieldProps {
  icon?: string;
  size?: 'small' | 'medium' | 'large';
}

export const CommandIconField: React.FC<CommandIconFieldProps> = ({ icon, size = 'medium' }) => {
  if (!icon) return null;

  // Try to get the icon component from Material-UI icons
  const IconComponent = (MuiIcons as any)[icon];

  if (!IconComponent) {
    return null;
  }

  const sizeMap = {
    small: 20,
    medium: 24,
    large: 32,
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <IconComponent sx={{ fontSize: sizeMap[size] }} />
    </Box>
  );
};
